<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="success"
        size="mini"
        
        @click="getList"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px;">乙方名称</label>
        <el-input
          v-model="name"
          placeholder="请输入乙方名称"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">账号</label>
        <el-input
          v-model="username"
          placeholder="请输入账号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">备注</label>
        <el-input
          v-model="memo"
          placeholder="请输入备注"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <el-checkbox style="margin-left: 20px;margin-top: 5px;" v-model="isDataToday">只看今日</el-checkbox>
      </div>
    </div>
    <!-- 表单 -->
    <div class="divTable">
      <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1511px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column type="selection" width="50"/> -->
      <el-table-column prop="address" label="操作" width="200">
        <template slot-scope="scope">
          <div>
            <el-button
                type="primary"
                class="edit-button"
                size="mini"
                @click="getChildrenSum(scope.row)"
                >子账号数据</el-button
              >
            <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="edit(scope.row)"
            >详情</el-button
          >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="乙方名称" width="100" />
      <el-table-column prop="totalRegister" label="注册数" width="100" />
      <el-table-column prop="totalRechargeCount" label="充值人数" width="100" />
      <el-table-column prop="totalWithdrawCount" label="提现人数" width="100" />
      <el-table-column prop="totalRecharge" label="充值金额" width="100" />
      <el-table-column prop="totalWithdraw" label="提现金额" width="100" />
      <el-table-column prop="totalRechargeTrx" label="充值TRX" width="100" />
      <el-table-column prop="totalRechargeUsdc" label="充值USDC" width="130" />
      <el-table-column prop="totalRechargeBtc" label="充值BTC" width="100" />
      <el-table-column prop="totalRechargeEth" label="充值ETH" width="100" />
      <el-table-column prop="totalRechargePol" label="充值POL" width="130" />
      <el-table-column prop="totalRechargeDai" label="充值DAI" width="130" />
      <el-table-column prop="totalAmount" label="账户余额" width="100" />
      <el-table-column label="跨线P2P">
        <template slot="header">
          <div style="background-color: #EDD5FF; color: #000;">跨线P2P</div>
        </template>
        <el-table-column prop="ccCrossBuyAmount" label="购买金额" width="110" />
        <el-table-column prop="ccCrossSaleAmount" label="出售金额" width="110" />
      </el-table-column>
      <el-table-column label="">
        <template slot="header">
          <div style="background-color: #CAF982; color: #000;">签到统计</div>
        </template>
         <el-table-column prop="signInTotalAmount" label="签到金额" width="100" />
         <el-table-column prop="signInTotalCount" label="签到账号数" width="100" />
      </el-table-column>
      <el-table-column prop="airdropMemberCount" label="收益人数" width="100" />
      <el-table-column prop="airdropTotalBuyCount" label="总投资人数" width="110" />
      <el-table-column prop="totalTeamAmount" label="团队余额" width="100" />
      <el-table-column label="">
        <template slot="header">
          <div style="background-color: #CAF982; color: #000;">充值-提现</div>
        </template>
         <el-table-column prop="yf7" label="0.7" width="100" />
         <el-table-column prop="yf6" label="0.6" width="100" />
         <el-table-column prop="yf5" label="0.5" width="100" />
      </el-table-column>
      <el-table-column label="">
        <template slot="header">
          <div style="background-color: #E9CDFF; color: #000;">空投</div>
        </template>
        <el-table-column prop="airdropTotalBuyAmount" label="USDT" width="100">
          <template #header>
            <div class="">
              <div class="gbRed">购买总金额</div>
              <div class="gbRed">USDT</div>
            </div> 
          </template>
      </el-table-column>
        <el-table-column prop="airdropTotalReceiveAmount" label="" width="100">
          <template #header>
            <div class="">
              <div class="gbRed">用户领取</div>
              <div class="gbRed">USDT</div>
            </div> 
          </template>
      </el-table-column>
      </el-table-column>
      <el-table-column prop="username" label="账号" width="100" />
      <el-table-column prop="ziAccountCount" label="子账号总数" width="100" />
      <el-table-column prop="memo" label="备注" width="100" />
      <el-table-column prop="address" label="是否启用" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isEnabled" style="color:#06CC00">启用</div>
          <div v-if="!scope.row.isEnabled" style="color:red">禁用</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="investBuyAmount" label="购买投资金额" width="100" />
      <el-table-column prop="investLingquAmount" label="投资领取收益" width="100" /> -->
      
    </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="1000px"
      title="详情"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <div>
        <div style="margin-bottom: 10px">
          <el-date-picker
      v-model="dataTime"
      type="daterange"
      value-format='yyyy-MM-dd'
      style="margin-right: 10px"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
    <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="yiFangDetail()"
        >筛选</el-button
      >
        </div>
        <div>
          <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="yiFangDetailList"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1541px"
      size="mini"
    >
      <el-table-column prop="date" label="日期" width="100">
        <template slot-scope="scope">{{ happenTimeFun(scope.row.date) == '9999-01-01'?'汇总':happenTimeFun(scope.row.date)}}</template>
      </el-table-column>
      <el-table-column prop="registerCount" label="注册人数" width="100" />
      <el-table-column prop="rechargeSum" label="充值金额" width="100" />
      <el-table-column prop="rechargeCount" label="充值人数" width="100" />
      <el-table-column prop="withdrawSum" label="提现金额" width="100" />
      <el-table-column prop="withdrawCount" label="提现人数" width="100" />
      <el-table-column prop="withdrawChargeSum" label="提现手续费" width="100" />
      <el-table-column prop="totalAmount" label="所有余额总和" width="100" />
      <el-table-column prop="totalTeamAmount" label="所有团队余额总和" width="100" />
      <el-table-column label="空投">
        <template slot="header">
          <div style="background-color: #E9CDFF; color: #000;">空投</div>
        </template>
        <el-table-column prop="airdropTotalBuyAmount" label="购买总金额USDT" width="100">
          <template #header>
            <div class="">
              <div class="gbRed">购买总金额</div>
              <div class="gbRed">USDT</div>
            </div> 
          </template>
      </el-table-column>
      
        <el-table-column prop="airdropTotalReceiveAmount" label="用户领取USDT" width="100">
          <template #header>
            <div class="">
              <div class="gbRed">用户领取</div>
              <div class="gbRed">USDT</div>
            </div> 
          </template>
      </el-table-column>
      </el-table-column>
    </el-table>
        </div>

      </div>
    </el-dialog>
    <!-- 下级团队 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      width="960px"
      title="子账号数据"
      :center="true"
      :close-on-click-modal="false"
    >
    <div>
      <el-table
      ref="gridTable"
      v-loading="loading" 
      :data="allChildrenSum"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="540px"
      style="width: 1050px"
      size="mini"
    >
      <el-table-column prop="memberUid" label="子账号名" width="150" />
      <el-table-column prop="totalRegister" label="注册数" width="150" />
      <el-table-column prop="totalRechargeCount" label="充值人数" width="150" />
      <el-table-column prop="totalWithdrawCount" label="提现人数" width="150" />
      <el-table-column prop="totalRecharge" label="充值USDT" width="150" />
      <el-table-column prop="totalWithdraw" label="提现USDT" width="150" />
      <el-table-column prop="totalRechargeUsdc" label="充值USDC" width="150" />
    </el-table>
    </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination,VueUeditorWrap },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: { },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      yiFangDetailList: [], // 
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      name:'',
      username:'',
      memo:'',
      isEnabled:false,
      isChat:false,
      isTelegram:false,
      isWhatsApp:false,
      isMessenger:false,
      isLinkUrl:false,
      isTelegramGroup:false,
      dialogVisible2:false,
      isDataToday:false,
      dataTime:['',''],
      allChildrenSum:[],
      yifangId:''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 子账号数据
    getChildrenSum(row){
        this.$api.operate
        .ziAccountData({
           yifangId: row.id
        })
        .then((res) => {
            this.allChildrenSum = res
            this.dialogVisible2 = true
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
        this.childrenSum()
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取表单信息
    getList() {
      var params = {
        // pageNumber: this.pageNum,
        // pageSize: this.pageSize,
        name:this.name,
        username:this.username,
        memo:this.memo
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      if(this.isDataToday){
        this.$api.operate
        .dataToday(params)
        .then((res) => {
          this.tableData = res;
          // this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
      }else{
        this.$api.operate
        .yifangData(params)
        .then((res) => {
          this.tableData = res;
          // this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
      } 
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .message2Delete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开编辑弹窗
    edit(row) {
      this.dialogVisible = true;
      this.yifangId = row.id
      let time = +new Date()
    let time1 = +new Date()-7*24*60*60*1000
    this.dataTime[0] = this.happenTimeFun(time1)
    this.dataTime[1] = this.happenTimeFun(time)
    this.yiFangDetail()
      
    },
    yiFangDetail(){
      this.$api.operate
            .yiFangDetail({
              yifangId:this.yifangId,
              startDate:this.dataTime[0],
              endDate:this.dataTime[1]
            })
            .then((res) => {
              this.yiFangDetailList = res
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });

    },
    happenTimeFun(num){
	let date = new Date(num);
	//时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM; //月补0
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d; //天补0
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h; //小时补0
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m; //分钟补0
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s; //秒补0
	return y + '-' + MM + '-' + d
},
    // 添加用户
    addManagement() {
          this.active.isChat =  this.isChat
          this.active.isEnabled =  this.isEnabled
          this.active.isTelegram =  this.isTelegram
          this.active.isWhatsApp =  this.isWhatsApp
          this.active.isMessenger =  this.isMessenger
          this.active.isLinkUrl =  this.isLinkUrl
          this.active.isTelegramGroup =  this.isTelegramGroup
          this.$api.operate
            .yiFangSave(this.active)
            .then((res) => {
              this.$message.success(res);
              this.dialogVisible = false;
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 更新用户信息
    editManagement() {
      this.$api.operate
        .yiFangUpdate(this.editForm)
        .then((res) => {
          this.$message.success(res);
          this.getList();
          this.edit_dialogVisible = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 打开删除弹窗
    open() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
   
  },
};
</script>
<style lang="scss" scoped>
 .divTable ::v-deep .el-table tr:first-child{
  background-color: #d9ffe6 !important;
}
// ::v-deep .el-table_1_column_16{
//   background-color: #CAF982 !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_1_column_20{
//   background-color: #80FFFF !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_1_column_24{
//   background-color: #00FFB4 !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_1_column_29{
//   background-color: #E9CDFF !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_1_column_34{
//   background-color: #FACD91 !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_2_column_47{
//   background-color: #FACD91 !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_2_column_52{
//   background-color: #00FFB4 !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_2_column_57{
//   background-color: #E9CDFF !important;
//   color: #000 !important;
// }
::v-deep .el-input__inner{
  padding: 0 8px !important;
}
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
::v-deep .el-input__inner{
  padding: 0 8px !important;
}
</style>
